// Every finance amount is net of IVA, which is handled outside TouchPoint (TD-101). The line under an amount the admin
// types says so, in the same words on every form.
export const WITHOUT_IVA = "Without IVA.";

export function WithoutIva() {
  return <span className="block text-xs text-gray-500 mt-1">{WITHOUT_IVA}</span>;
}
